import React from "react";

interface RBPayWordmarkProps {
  className?: string;
  style?: React.CSSProperties;
  payClassName?: string;
  payStyle?: React.CSSProperties;
}

export const RBPayWordmark: React.FC<RBPayWordmarkProps> = ({
  className,
  style,
  payClassName,
  payStyle,
}) => (
  <span className={className} style={style}>
    RB <span className={payClassName} style={{ fontStyle: "italic", ...payStyle }}>Pay</span>
  </span>
);

export const renderRBPayText = (text?: string | null): React.ReactNode => {
  if (!text || !text.includes("RB Pay")) {
    return text || "";
  }

  const parts = text.split("RB Pay");

  return parts.map((part, index) => (
    <React.Fragment key={`${part}-${index}`}>
      {index > 0 ? <RBPayWordmark /> : null}
      {part}
    </React.Fragment>
  ));
};